
export enum PhotoTypeCd {
	CLOSE_PHOTO = 'ClosePhoto',
	LOAD_PHOTO = 'LoadPhoto',
	OPEN_PHOTO = 'OpenPhoto'}

